/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { h, render } from "preact";
import styled from "styled-px2rem";
import { Mask, Toast } from "antd-mobile";
import { useState, useEffect } from "preact/hooks";
import "./detailpop.css";
import CopyText from "react-copy-text";
const MaskWrap = ({ type,tbToken,callBack }: any) => {
    const [visible, setVisible] = useState(false);
    const [text, setText] = useState("");
    useEffect(() => {
        setVisible(true);
    }, [])
    return (<Mask className="z_9999" visible={visible} disableBodyScroll={true}>
        <Container>
          {
            type==1&&<Content>
                <Title>口令购买</Title>
                <TklContent>{tbToken}</TklContent>
                <CopyText text={text} />
                <CopyBtn onClick={() => {
                     const ContainerDiv: any=document.getElementById("container");
                      setText(tbToken);
                      Toast.show({ content: "淘口令复制成功,请前往淘宝打开" })
                      setTimeout(() => {
                          render(null, ContainerDiv);
                      }, 100);
                    }}>一键复制</CopyBtn>
            </Content>
          }
           {
            type==2&&<Content>
                <Title>分享链接</Title>
                <TklContent>{tbToken}</TklContent>
                <CopyText text={text} />
                <CopyBtn onClick={() => {
                     const ContainerDiv: any=document.getElementById("container");
                      setText(tbToken);
                      Toast.show({ content: "复制成功" })
                      setTimeout(() => {
                          render(null, ContainerDiv);
                      }, 100);
                    }}>一键复制</CopyBtn>
            </Content>
          }
        </Container>
    </Mask>);
}
const TokenPopup = {
    close: () => {
        const ContainerDiv: any = document.getElementById("container");
        render(null, ContainerDiv);
    },
    showToken: (type=1,tbToken="",callBack=()=>{}) => {
        const ContainerDiv: any = document.getElementById("container");
        render(<MaskWrap type={type} tbToken={tbToken} callBack={callBack} />, ContainerDiv);
    },
};
export default TokenPopup;
const Container = styled.div`
    width:100vw;
    height:100vh;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
`;
const Content = styled.div`
   width: 560px;
   background: #FFFFFF;
   border-radius: 20px;
   padding: 80px 28px 40px 28px;
   display: flex;
   flex-direction: column;
   align-items: center;
`;
const Title=styled.div`
    width: 100%;
    text-align: center;
    font-weight: 600;
    color: #000000;
    line-height: 44px;
    font-size:34px;
`;
const TklContent=styled.div`
    margin-top:42px;
    width: 100%;
    padding: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
    font-size: 28px;
    background: #F6F6F6;
    border-radius: 20px;
`;
const CopyBtn=styled.div`
    margin-top:56px;
    width: 240px;
    height: 72px;
    background: linear-gradient(90deg, #FF9059 0%, #FA483E 100%);
    border-radius: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    color: #FFFFFF;
    font-size:30px;
`